import {
  TEntityResponse,
  TEntityListResponse,
  TDeviceProfileStateResBody,
  TDeviceProfileStateSummaryResBody,
} from '@poseidon-city/shared';

import { TAPIClient } from '../client';

type TDeviceProfileStatesClient = {
  get(id: string): Promise<TEntityResponse<'device-profile-state', TDeviceProfileStateResBody> | undefined>;
  list(
    limit: number,
    page: number
  ): Promise<TEntityListResponse<'device-profile-state', TDeviceProfileStateSummaryResBody> | undefined>;
};

function DeviceProfileStatesClient(apiClient: TAPIClient): TDeviceProfileStatesClient {
  return {
    async get(id: string): Promise<TEntityResponse<'device-profile-state', TDeviceProfileStateResBody> | undefined> {
      const data = await apiClient.get<TEntityResponse<'device-profile-state', TDeviceProfileStateResBody>>(
        `/device-profile-states/${id}`
      );

      if (data && data.type !== 'device-profile-state') {
        throw new Error('Invalid entity type received, expected: device-profile-state, received: ' + data.type);
      }

      return data;
    },
    async list(
      limit: number,
      page: number
    ): Promise<TEntityListResponse<'device-profile-state', TDeviceProfileStateSummaryResBody> | undefined> {
      const data = await apiClient.get<TEntityListResponse<'device-profile-state', TDeviceProfileStateSummaryResBody>>(
        `/device-profile-states?limit=${limit}&page=${page}`
      );

      if (data && data.type !== 'device-profile-state') {
        throw new Error('Invalid entity type received, expected: device-profile-state, received: ' + data.type);
      }

      return data;
    },
  };
}

export { TDeviceProfileStatesClient, DeviceProfileStatesClient };
